import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ikonIndikator } from "../../utils/indicatorIcon";
import React from "react";
import { Badge, Card, Col, Row } from "react-bootstrap";
import { formatAngka, formatDelta } from "../../utils";

// Tier data ikut ditempel di kartu klaim: angka penghematan tanpa keterangan
// kualitas datanya mudah dikutip keluar sebagai fakta padahal belum tentu layak.
const warnaTier = (tier) => {
  if (tier === "T1") return "success";
  if (tier === "T2") return "primary";
  if (tier === "T3") return "warning";
  return "secondary";
};

function PanelSavings({ items, baselineDipakai }) {
  const cariBaseline = (code) =>
    (baselineDipakai || []).find(
      (b) => b.indicator_code === code
    );

  if (!items || items.length === 0) {
    return (
      <div className="text-muted" style={{ fontSize: "12px" }}>
        Belum ada indikator penghematan pada periode ini.
      </div>
    );
  }

  return (
    <Row className="g-2">
      {items.map((val) => {
        const baseline = cariBaseline(val.code);
        const perKg =
          val.total_weight_kg > 0 ? val.total_saved / val.total_weight_kg : null;
        const delta = Number(val.delta_vs_prev);

        return (
          <Col key={val.code} xs={12} md={6} xl={4}>
            <Card className="h-100 shadow-sm border-0">
              <Card.Body className="p-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="fw-bold" style={{ fontSize: "13px" }}>
                    <FontAwesomeIcon
                      icon={ikonIndikator(val.icon)}
                      className="me-2 text-secondary"
                    />
                    {val.nama}
                  </div>
                  <Badge bg={warnaTier(val.quality_tier)}>
                    {val.quality_tier || "-"}
                  </Badge>
                </div>

                <div className="mt-2">
                  <span className="fw-bold" style={{ fontSize: "24px" }}>
                    {formatAngka(val.total_saved)}
                  </span>
                  <span className="ms-1 text-muted" style={{ fontSize: "12px" }}>
                    {val.unit}
                  </span>
                </div>
                <div className="text-muted" style={{ fontSize: "11px" }}>
                  dihemat pada periode ini
                </div>

                <div className="mt-2" style={{ fontSize: "11px" }}>
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Per order</span>
                    <span>
                      {formatAngka(val.saved_per_order)} {val.unit}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Per kg</span>
                    <span>
                      {perKg === null ? "-" : `${formatAngka(perKg, 3)} ${val.unit}`}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Jumlah order</span>
                    <span>{formatAngka(val.order_count, 0)}</span>
                  </div>
                </div>

                <div className="mt-2 d-flex justify-content-between align-items-center">
                  <Badge bg={delta >= 0 ? "success" : "danger"}>
                    {formatDelta(val.delta_vs_prev)} vs periode lalu
                  </Badge>
                  <span className="text-muted" style={{ fontSize: "10px" }}>
                    Baseline: {baseline ? `${baseline.tipe} (${baseline.quality_tier})` : "tidak tercatat"}
                  </span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
}

export default PanelSavings;
